<template>
  <r-toggle-card
    title="Эпюры"
    :is-open="config.enabled"
    @toggle="toggleHandler"
  >
    <div class="c-diagram">
      <r-color-picker
        :color="config.color"
        :color-opacity="config.opacity"
        @change="changeColorProperty"
      />
      <r-slider
        style="margin-top: 8px;"
        title="Ширина"
        :number="config.width"
        :min="100"
        :max="1000"
        :step="10"
        @change="changeWidthProperty"
      />
      <div class="c-diagram__field">
        <r-text type="caption" style="margin-bottom: 8px;">
          По атрибуту
        </r-text>
        <c-attributes
          :id="id"
          :config="config"
          field="field"
          @update="updateField"
        />
      </div>
    </div>
  </r-toggle-card>
</template>

<script>
import CAttributes from "../attributes/attributes";

export default {
  components: {
    CAttributes
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    config() {
      return this.$store.state.calculations.stylesConfigs[this.id].diagram;
    }
  },
  methods: {
    toggleHandler(value) {
      this.config.enabled = value;

      this.$cControllers.diagram.toggleDiagram(this.id);
    },
    updateField(value) {
      if (value) {
        const { objectFields } = this.$store.state.calculations;
        const fields = objectFields[this.id];
        const { max, min } = fields.find(f => f.title === value);

        this.$set(this.config, "minValue", min);
        this.$set(this.config, "maxValue", max);
      }

      this.$cControllers.diagram.addDiagramLayer(this.id);
    },
    changeColorProperty({ color, opacity }) {
      this.config.color = color;
      this.config.opacity = opacity;

      this.$cControllers.diagram.changeDiagramProperty(this.id, "color");
      this.$cControllers.diagram.changeDiagramProperty(this.id, "opacity");
    },
    changeWidthProperty(value) {
      this.config.width = value;

      this.$cControllers.diagram.addDiagramLayer(this.id);
    }
  }
};
</script>

<style lang="scss">
.c-diagram {
  &__field {
    margin-top: 16px;

    .r-select {
      width: 100%;
    }
  }
}
</style>
